import React, { useEffect } from "react";
import DataTable from "./DataTable";
import { CloseIcon } from "./Icons";

/** Full-screen view of one result table. */
export default function TableModal({ table, onClose }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") {
        e.stopPropagation();
        onClose();
      }
    };
    document.addEventListener("keydown", onKey, true);
    return () => document.removeEventListener("keydown", onKey, true);
  }, [onClose]);

  return (
    <div className="bdai-modal" role="dialog" aria-modal="true" aria-label={table.title} onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className="bdai-modal-card">
        <div className="bdai-modal-head">
          <h3>{table.title}</h3>
          <button type="button" className="bdai-icon-btn" onClick={onClose} aria-label="Close">
            <CloseIcon size={18} />
          </button>
        </div>
        <div className="bdai-modal-body">
          <DataTable title={table.title} rows={table.rows || []} fullView />
        </div>
      </div>
    </div>
  );
}
